import {
  Activity,
  Anchor,
  Brain,
  CloudFog,
  Fence,
  HandHeart,
  Heart,
  HeartHandshake,
  Leaf,
  Link2,
  Sparkles,
  Target,
  Snowflake,
  Compass,
  Zap,
  Wind,
  Users,
  Handshake,
  ShieldAlert,
  RefreshCw,
  MessageCircle,
  CircleSlash,
  BrickWall,
  Baby,
  Moon,
  Waves,
  type LucideIcon,
} from "lucide-react";

export type AssessmentTheme = {
  /** CSS class defined in src/styles.css that carries the soft colour tokens. */
  themeClass: string;
  Icon: LucideIcon;
};

const THEMES: Record<string, AssessmentTheme> = {
  "trauma-responses": { themeClass: "assess-lavender", Icon: Brain },
  "people-pleasing": { themeClass: "assess-peach", Icon: HandHeart },
  boundaries: { themeClass: "assess-sage", Icon: Fence },
  hypervigilance: { themeClass: "assess-sky", Icon: Activity },
  "emotional-regulation": { themeClass: "assess-purple", Icon: Waves },
  "nervous-system": { themeClass: "assess-teal", Icon: Leaf },
  dissociation: { themeClass: "assess-sky", Icon: CloudFog },
  numbness: { themeClass: "assess-lavender", Icon: Sparkles },
  attachment: { themeClass: "assess-pink", Icon: HeartHandshake },
  "trauma-bonds": { themeClass: "assess-purple", Icon: Link2 },
  "self-worth": { themeClass: "assess-peach", Icon: Heart },
  relationships: { themeClass: "assess-teal", Icon: Anchor },
  "trigger-patterns": { themeClass: "assess-peach", Icon: Target },
  "functional-freeze": { themeClass: "assess-sky", Icon: Snowflake },
  "survival-mode": { themeClass: "assess-sage", Icon: Compass },
  "emotional-flashbacks": { themeClass: "assess-purple", Icon: Zap },
  "anxiety-patterns": { themeClass: "assess-lavender", Icon: Wind },
  "self-compassion": { themeClass: "assess-pink", Icon: Heart },
  "fear-of-abandonment": { themeClass: "assess-pink", Icon: Users },
  "trust-after-trauma": { themeClass: "assess-teal", Icon: Handshake },
  "relationship-safety": { themeClass: "assess-peach", Icon: ShieldAlert },
  "overthinking-rumination": { themeClass: "assess-lavender", Icon: RefreshCw },
  "inner-critic": { themeClass: "assess-purple", Icon: MessageCircle },
  "avoidance-patterns": { themeClass: "assess-sky", Icon: CircleSlash },
  "hyper-independence": { themeClass: "assess-sage", Icon: BrickWall },
  "childhood-emotional-neglect": { themeClass: "assess-peach", Icon: Baby },
  "sleep-and-trauma": { themeClass: "assess-sky", Icon: Moon },
};

const FALLBACK_ORDER = [
  "assess-lavender",
  "assess-teal",
  "assess-peach",
  "assess-sage",
  "assess-pink",
  "assess-sky",
  "assess-purple",
];

export function getAssessmentTheme(slug: string, index = 0): AssessmentTheme {
  return (
    THEMES[slug] ?? {
      themeClass: FALLBACK_ORDER[index % FALLBACK_ORDER.length],
      Icon: Sparkles,
    }
  );
}
